import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prjectMgm, auditBaseUrl } from '../endpoints';
// Define a service using a base URL and expected endpoints
export const timeSheetService = createApi({
    reducerPath: 'timeSheetService',
    baseQuery: fetchBaseQuery({ baseUrl: auditBaseUrl }),
    tagTypes: ['TimeSheet'],
    endpoints: (builder) => ({
        getAllTimeSheet: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.timeSheetController.getAllTimeSheet}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getTimeSheetById: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.timeSheetController.getTimeSheetById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        saveTimeSheet: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.timeSheetController.saveTimeSheet}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateTimeSheet: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.timeSheetController.updateTimeSheet}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteTimeSheet: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.timeSheetController.deleteTimeSheet}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getAllTimeSheetWithSearch: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.timeSheetController.getAllTimeSheetWithSearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),
        findAllTimeSheet: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.timeSheetController.findAllTimeSheet}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        findAllMentors: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.timeSheetController.findAllMentors}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        filterTimeSheets: builder.mutation({
            query(body) {
                const params = new URLSearchParams();

                // Add parameters only if they are non-empty
                if (body.payload.department) {
                    params.append("department", body.payload.department);
                }
                if (body.payload.projectMentor) {
                    params.append("mentor", body.payload.projectMentor);
                }
                if (body.payload.organizationName) {
                    params.append("organization", body.payload.organizationName);
                }
                if (body.payload.projectType) {
                    params.append("projectType", body.payload.projectType);
                }
                if (body.payload.sponsor) {
                    params.append("sponsor", body.payload.sponsor);
                }
                return {
                    url: `${prjectMgm.timeSheetController.filterTimeSheets}?${params.toString()}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
    })
});
export const {
    useGetAllTimeSheetMutation,
    useSaveTimeSheetMutation,
    useUpdateTimeSheetMutation,
    useDeleteTimeSheetMutation,
    useGetTimeSheetByIdMutation,
    useGetAllTimeSheetWithSearchMutation,
    useFindAllTimeSheetMutation,
    useFindAllMentorsMutation,
    useFilterTimeSheetsMutation,
} = timeSheetService;